<template>
  <el-dialog
    title="咨询详情"
    :visible.sync="visible"
    top="20vh"
    width="600px"
    :lock-scroll="false"
    :close-on-click-modal="false"
    @close="closeDialog"
  >
    <div class="counsel-info">
      <div>
        <span>倾向导师：</span>
        <p>{{ info.name }}</p>
      </div>
      <div>
        <span>联系方式：</span>
        <p>{{ info.linkMode }}</p>
      </div>
      <div>
        <span>职位：</span>
        <p>{{ info.jobName }}</p>
      </div>
      <div>
        <span>企业名称：</span>
        <p>{{ info.companyName }}</p>
      </div>
      <div>
        <span>您的诉求：</span>
        <p>{{ info.hopeInfo }}</p>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    counselId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      visible: true,
      info: {}
    };
  },
  created() {
    this.loadInfo();
  },
  methods: {
    // 关闭弹框后回调
    closeDialog() {
      // 传递关闭上一级
      this.$emit("close", true);
    },
    // 逆向处理数据 获取后进行数据处理回显
    downloadProcessData(data) {
      return data;
    },
    // 加载数据接口
    loadInfo() {
      this.$api("mentor", "getCounselInfo", { id: this.counselId }).then(
        (res) => {
          const { code, message } = res;
          if (code === 0) {
            this.info = this.downloadProcessData(res.dataList[0]);
          } else {
            this.$message.error(message);
          }
        }
      );
    }
  }
};
</script>

<style lang="less" scoped>
.counsel-info {
  > div {
    display: flex;
    span {
      flex: none;
      width: 108px;
      padding-right: 12px;
      line-height: 40px;
      text-align: right;
    }
    p {
      padding: 8px 0;
      line-height: 24px;
    }
  }
}
</style>
